import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  Container,
  FormFeedback,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import Dropzone from "react-dropzone"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"
import {
  createPvsCategory,
  resetPvsCategoryState,
} from "../../../redux/actions/pvs"

function AddPvsCategory() {
  document.title = "Add Pvs Category | PVS | Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()

  const createCategoryScreen = useSelector(
    state => state.screens.pvs.createPvsCategory
  )

  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [selectedPvsCategoryFiles, setSelectedPvsCategoryFiles] = useState([])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      category: "",
      description: "",
    },
    validationSchema: Yup.object({
      category: Yup.string().required("Please Enter Category Name"),
      // description: Yup.string().required("Please Enter Description"),
    }),
    onSubmit: values => {
      const formData = new FormData()
      // Append text fields
      formData.append("category", values.category)
      formData.append("description", values.description)
      if (selectedPvsCategoryFiles[0])
        formData.append("pvs_category_icon", selectedPvsCategoryFiles[0])
      dispatch(createPvsCategory(formData))
    },
  })

  useEffect(() => {
    if (createCategoryScreen.success) {
      setSuccessOpen(true)
    } else if (createCategoryScreen.error) {
      setErrorMsg(createCategoryScreen.message)
      setErrorOpen(true)
    }
  }, [createCategoryScreen])

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          dispatch(resetPvsCategoryState())
          history("/pvs-category", { replace: true })
        }}
        message={"Category Added Successfully!"}
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => {
          setErrorOpen(false)
          dispatch(resetPvsCategoryState())
        }}
        message={errorMsg}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="PVS"
            title="Category"
            breadcrumbItem="Add PVS Category"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="category">
                          Category <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="category"
                          className="form-control"
                          placeholder="Enter category name"
                          type="text"
                          id="category"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.category || ""}
                          invalid={
                            validation.touched.category &&
                            validation.errors.category
                              ? true
                              : false
                          }
                        />
                        {validation.touched.category &&
                        validation.errors.category ? (
                          <FormFeedback type="invalid">
                            {validation.errors.category}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="description">
                          Description
                        </Label>
                        <textarea
                          name="description"
                          id="description"
                          className={`form-control ${
                            validation.touched.description &&
                            validation.errors.description
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                        />
                        {validation.touched.description &&
                        validation.errors.description ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-md-4">
                        <Label
                          className="form-label"
                          htmlFor="pvs_category_icon"
                        >
                          PVS Category Icon
                        </Label>
                        <Dropzone
                          onDrop={acceptedFiles => {
                            setSelectedPvsCategoryFiles(acceptedFiles)
                            validation.setFieldValue(
                              "pvs_category_icon",
                              acceptedFiles[0]
                            )
                          }}
                          multiple={false}
                          accept={{ "image/*": [] }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="mdi mdi-cloud-upload display-4 text-muted"></i>
                                </div>
                                <h4>Drop files here or click to upload.</h4>
                                {/*   <div className="text-muted mb-2" style={{ fontSize: '0.55em' }}>
                                    Image size must be <b>416 × 208 px</b>
                                  </div> */}
                                {selectedPvsCategoryFiles &&
                                  selectedPvsCategoryFiles.length > 0 && (
                                    <div className="mt-2">
                                      <img
                                        src={URL.createObjectURL(
                                          selectedPvsCategoryFiles[0]
                                        )}
                                        alt="Icon Preview"
                                        style={{
                                          maxWidth: "200px",
                                          maxHeight: "120px",
                                          borderRadius: "4px",
                                          border: "1px solid #eee",
                                        }}
                                      />
                                    </div>
                                  )}
                                {/*    {(!selectedPvsCategoryFiles || selectedPvsCategoryFiles.length === 0) && userPvsData?pvs_category_icon_path && (
                                    <div className="mt-2">
                                      <img
                                        src={userPvsDatapvs_category_icon_path}
                                        alt="Icon Front"
                                        style={{ maxWidth: '200px', maxHeight: '120px', borderRadius: '4px', border: '1px solid #eee' }}
                                      />
                                    </div>
                                  )} */}
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        {/* View File link outside Dropzone, centered */}
                        {selectedPvsCategoryFiles &&
                          selectedPvsCategoryFiles.length > 0 && (
                            <div className="mt-1 d-flex justify-content-center">
                              <a
                                href={URL.createObjectURL(
                                  selectedPvsCategoryFiles[0]
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View File
                              </a>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        type="submit"
                        color="primary"
                        size="lg"
                        className="mt-3"
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddPvsCategory
